var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareNetwork = function SvgIconShareNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.783 8.186A4 4 0 1 0 12.7 6.504l-3.983 2.56a4 4 0 1 0 0 5.872l3.984 2.56a4 4 0 1 0 1.083-1.682l-3.985-2.56a3.996 3.996 0 0 0 0-2.508zM16.5 3.25a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8.845 7.627a1 1 0 0 0 .054.084C7.894 11.264 8 11.62 8 12a2 2 0 0 1-.345 1.123 2 2 0 1 1 0-2.246m7.136 6.834a1 1 0 0 0 .054-.084 2 2 0 1 1-.054.084",
    clipRule: "evenodd"
  })));
};
export default SvgIconShareNetwork;